import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import NavigationButton from '../navigation/navigationButton';
import LanguageSwitch from '../../molecules/language-switch/languageSwitch';
import SearchButton from '../search-bar/searchButton';
import StyledModalHeader from './modalHeader.style';
import AccessibilityButton from '../../molecules/accessibility-meta/accessibilityButton';

const ModalHeader = props => {
  const { navIsOpen, searchIsOpen, accessibilityIsOpen, currentLevel } = props;

  return (
    <StyledModalHeader {...props} currentLevel={currentLevel}>
      <NavigationButton inverted close={navIsOpen} className="modalHeader__navigation-button" />
      <SearchButton inverted close={searchIsOpen} className="modalHeader__search-button" />
      <AccessibilityButton
        inverted
        close={accessibilityIsOpen}
        className="modalHeader__accessibility-button"
      />
      <LanguageSwitch inverted className="modalHeader__language-switch" />
    </StyledModalHeader>
  );
};

ModalHeader.propTypes = {
  locale: PropTypes.oneOf([PropTypes.shape(), PropTypes.arrayOf(PropTypes.shape())]),
  currentLevel: PropTypes.number.isRequired,
  navIsOpen: PropTypes.bool.isRequired,
  searchIsOpen: PropTypes.bool.isRequired,
  accessibilityIsOpen: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  navIsOpen: state.navigation.isOpen,
  searchIsOpen: state.search.isOpen,
  accessibilityIsOpen: state.accessibility.isOpen,
  currentLevel: state.navigation.currentLevel
});

export default connect(mapStateToProps)(ModalHeader);
